import React, { useState, useEffect } from "react";
import CurrencyInput from "react-currency-input-field";
import ReactSlider from "react-slider";
import "./index.79eb4998.css";

function InputRange({
  fieldName,
  value,
  setValue,
  trigger,
  testId,
  maxLimitValue,
  tempValue, 
  setTempValue
}) {
  const [typingTimeout, setTypingTimeout] = useState(0);

  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  const handleValueChange = (newValue, index) => {
    // Clear any existing timeout
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Update the temporary value immediately
    const updatedValue = [...tempValue];
    updatedValue[index] = Number(newValue) || 0;
    setTempValue(updatedValue);

    // Set a new timeout to update the actual value after 1 second of inactivity
    setTypingTimeout(
      setTimeout(() => {
        let finalValue = [...updatedValue];

        // Ensure values are within limits
        if (finalValue[index] > maxLimitValue) {
          finalValue[index] = maxLimitValue;
        }

        // Apply min/max logic
        if (index === 0) {
          // Min value changed
          if (finalValue[0] > finalValue[1]) {
            finalValue[1] = finalValue[0];
          }
        } else {
          // Max value changed
          if (finalValue[1] < finalValue[0]) {
            finalValue[0] = finalValue[1];
          }
        }

        setValue(fieldName, finalValue);
        trigger(fieldName);
        setTempValue(finalValue);
      }, 1500) // 1 second delay
    );
  };

  return (
    <div>
      <div style={{ width: 410 }}>
        <div
          className="grid grid-cols-3 w-[325px]"
          aria-labelledby="closing_date"
          role="application"
        >
          <div>
            <h1 className="font-bold pb-1.5">Min Total</h1>
            <div className="custom__icon-textfield w-[180px]">
              <CurrencyInput
                id={fieldName}
                value={tempValue[0] || 0}
                allowDecimals={false}
                allowNegativeValue={false}
                onValueChange={(val) => {
                  handleValueChange(val, 0);
                }}
                data-cy={testId}
              />
              <div className="icon-box">$</div>
            </div>
          </div>
          <div className="mr-0">
            <img
              src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMiIgdmlld0JveD0iMCAwIDEwIDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxsaW5lIHkxPSIxLjI1IiB4Mj0iMTAiIHkyPSIxLjI1IiBzdHJva2U9IiMyMzFGMjAiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="
              className="align-middle justify-center mt-12 z-50"
              style={{ marginLeft: 85 }}
              alt=""
              width="10px"
            />
          </div>
          <div>
            <h1 className="font-bold pb-1.5">Max Total</h1>
            <div className="custom__icon-textfield w-[180px]">
              <CurrencyInput
                id={fieldName}
                value={tempValue[1] || 0}
                allowDecimals={false}
                allowNegativeValue={false}
                onValueChange={(val) => {
                  handleValueChange(val, 1);
                }}
                data-cy={testId}
              />
              <div className="icon-box">$</div>
            </div>
          </div>
        </div>
        <div
          className="mt-3 w-[325px]"
          aria-labelledby="range_slider"
          role="application"
        >
          <div className="wrapper">
            <ReactSlider
              min={0}
              max={maxLimitValue}
              value={value}
              onChange={(val, index) => {
                setValue(fieldName, val);
                setTempValue(val);
                trigger(fieldName);
              }}
              className="slider_container"
              thumbClassName="inputThumb "
              withTracks
              trackClassName="example-track"
              renderTrack={(props, state) => (
                <div {...props}>
                  <span style={{ display: "none" }}>{state.valueNow}</span>
                </div>
              )}
            />
            <div className="values" style={{ width: 400 }}>
              <span id="thumb1_value">{value[0]}</span>
              <span id="thumb2_value" className="float-right">
                {value[1]}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(InputRange);
